module.exports = __webpack_public_path__ + "static/media/m5.5ea08a34.png";